angular.module('wbControllers').controller 'LoginControllerStaff',
['$scope', '$location', '$route', 'users', 'storage', 'analytics', ($scope, $location, $route, users, storage, analytics) ->
    @user = users.getCurrentUser() || {}
    @message = null
    @state = undefined

    @showLogin = =>
      @forgotPassword = false

    @loginViaGoogleSSO = =>
      @state = 'redirecting'
      window.location = '/sso/initiate'

    @
]
